import React from 'react';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom'; 
import styles from './CustomerNav.module.css';

import HomeActiveIcon from '../icons/Menu/HomeActiveIcon';
import HomeInactiveIcon from '../icons/Menu/HomeInactiveIcon';
import ScanQr from '../icons/ScanQR';
import ETicketsIcon from '../icons/Menu/EticketsIcon';
import ETicketsIconInverter from '../icons/Menu/EticketsIconInverter';
import EventIcon from '../icons/Menu/EventIcon';
import EventIconInverter from '../icons/Menu/EventIconInverter';
import RestaurantListIcon from '../icons/Menu/restaurantListIcon';
import RestaurantListIconInverter from '../icons/Menu/RestaurantListIconInverter';

const CustomerNav = () => {
  const location = useLocation();
  const history = useHistory(); 

  const hash = location.pathname;

  const pathname = {
    home: '/',
    eTickets: '/e-tickets',
    payment: '/scan-payment',
    restaurantList: '/restaurant-list',
    events: '/events',
  };

  return (
    <div className={`${styles.menuNav} position-fixed w-100`}>
      <div className="container">
        <div className="row justify-content-center">
          <div className={`col-12 col-md-7 col-lg-6 ${styles.customerNavConsumer}`}>
            <div className="row px-2">

              <div className="col" onClick={() => history.push('/')}>
                <div className={`${styles.link} ${hash === pathname.home ? styles.active : ''}`}>
                  {hash === pathname.home ? (
                    <HomeActiveIcon size="24px" color="#1d9bf0" />
                  ) : (
                    <HomeInactiveIcon size="24px" color="#FFF" />
                  )}
                </div>
              </div>

              <div className="col" onClick={() => history.push('/restaurant-list')}>
                <div className={`${styles.link} ${hash === pathname.restaurantList ? styles.active : ''}`}>
                  {hash === pathname.restaurantList ? (
                    <RestaurantListIcon size="24px" color="#1d9bf0" />
                  ) : (
                    <RestaurantListIconInverter size="24px" color="#D9D9D9" />
                  )}
                </div>
              </div>
              <div className="col" onClick={() => history.push('/scan-payment')}>
                <div className={`${styles.outerCircle} ${hash === pathname.payment ? styles.active : ''}`}>
                  <div>
                    {hash === pathname.payment ? (
                      <ScanQr size="32px" color="#1d9bf0" />
                    ) : (
                      <ScanQr size="32px" color="#D9D9D9" />
                    )}
                  </div>
                </div>
              </div>

              <div className="col" onClick={() => history.push('/events')}>
                <div className={`${styles.link} ${hash === pathname.events ? styles.active : ''}`}>
                  {hash === pathname.events ? (
                    <EventIconInverter size="24px" color="#1d9bf0" />
                  ) : (
                    <EventIcon size="24px" color="#D9D9D9" />
                  )}
                </div>
              </div>

              <div className="col" onClick={() => history.push('/e-tickets')}>
                <div className={`${styles.link} ${hash === pathname.eTickets ? styles.active : ''}`}>
                  {hash === pathname.eTickets ? (
                    <ETicketsIconInverter size="24px" color="#1d9bf0" />
                  ) : (
                    <ETicketsIcon size="24px" color="#D9D9D9" />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerNav;
